/** @jsx jsx */
/* eslint-disable no-use-before-define */
import { jsx } from '@emotion/core'
import { backgroundColor, } from './style.js'
import React from 'react'
import { Header } from './header'
import { Account } from './account'
import { Footer } from './footer'
import { useOrderTicket, STEPS, MODES } from './use-order-ticket'
import { isNumeric, fmt, show, parseHtml, safeURL, openWindow, viewBack, Flyout } from '../twd'

export const Preview = () => {

    return <React.Fragment>

        <div className="container order-ticket">
        <Header />
        </div>

        <div style={{backgroundColor:"#f6f6f6"}}>
        <div className="container">
            <Account />
        </div>
        </div>

        <div css={backgroundColor}>
        <div className="xs-hide container">
            <Content />
        </div>
        <div className="xs-show container">
            <ContentMobile />
        </div>
        </div>

        <div style={{backgroundColor:"#f6f6f6"}}>
        <div className="container">
        <div className="xs-show row vertical-offset-sm"></div>
        <div className="row vertical-offset-sm"><div className="col-md-12">
            Important: Your are placing an order. Click only once to avoid placing multiple orders.
        </div></div>
        </div>
        </div>

        <Footer />
        </React.Fragment>
}

const ContentMobile = () => {
    const { bondInfo, orderInfo, isRfq, mode, isTreasuryAuction } = useOrderTicket()
    const netMoneyLabel = ['W','S'].indexOf(orderInfo.action)>=0 ? 'Estimated proceeds'
        : 'Estimated total cost'

    const issue = bondInfo.issue || {}
    const isLift = mode === MODES.ORDER_Z
    const priceUi = orderInfo.primary==='Y' || isLift ? orderInfo.price : orderInfo.dealerPrice
    const isNoCalc = bondInfo.issue && ['O','K'].includes(bondInfo.issue.type)
    const ytm = !isNumeric(orderInfo.YTM) ? null
        : orderInfo.YTM===0.0 && isNoCalc ? null
        : orderInfo.YTM
    const ytw = !isNumeric(orderInfo.YTW) ? null
        : orderInfo.YTW===0.0 && isNoCalc ? null
        : orderInfo.YTW

    return <React.Fragment>
        <div className="row vertical-offset-base"><div className="col-md-12">

        <div className="vertical-offset-base" style={{backgroundColor:'#ffffff'}}>
            <div className="row vertical-offset-base"></div>

            <div className="row vertical-offset-base"><div className="col-md-12">
                <div><Flyout
                    label="Issuer"
                    html={`A legal entity (such as a corporation, government, or municipality) which borrows money by issuing bonds.
                        The issuer is obligated to pay the principal and interest on the bond.`}
                /></div>
                <h2>{parseHtml(issue.issue)}</h2>
            </div></div>

            <hr aria-hidden={true} className="vertical-offset-base" />

            <Labeled label="Action" value={getAction(orderInfo.action)} />
            <Labeled label="CUSIP" value={orderInfo.cusip} />
            <Labeled label="Quantity" value={fmt.qty(orderInfo.qty)} />
            <Labeled label="Execution Type" value={orderInfo.executionType} />
            <Labeled label="Settlement Date" value={orderInfo.settlement} />
            <Labeled label="Maturity Date" value={orderInfo.maturity} />
            <Labeled label="Yield to maturity" value={isNumeric(ytm) ? fmt.ytw3(ytm) : fmt.empty()} />
            <Labeled label="Yield to worst" value={isNumeric(ytw) ? fmt.ytw3(ytw) : fmt.empty()} />
            <Labeled label="Price" value={
                isTreasuryAuction ? 'Auction'
                : isNumeric(priceUi) ? '$' + fmt.price3(priceUi)
                : fmt.empty()
                } />

            <hr aria-hidden={true} className="vertical-offset-base" />

            <Labeled label="Principal" value={
                isTreasuryAuction ? fmt.empty() : fmt.money(isRfq ? 0 : orderInfo.principal)
                } />
            <Labeled label="Accrued interest" value={
                isTreasuryAuction ? fmt.empty()
                : orderInfo.accruedInterest ? <React.Fragment>{fmt.money(orderInfo.accruedInterest)} ({fmt.count(orderInfo.accruedInterestDays)} days)</React.Fragment>
                : fmt.money(isRfq ? 0 : null)
                } />
            <Labeled label="Commission" value={
                isTreasuryAuction ? fmt.empty() : fmt.money(isRfq ? 0 : orderInfo.sugg_comm_in_dlrs_per_tckt)
                } />
            <Labeled label={netMoneyLabel} value={
                isTreasuryAuction ? fmt.empty() : fmt.money(isRfq ? 0 : orderInfo.netMoney)
                } />

            <div className="row vertical-offset-sm"><div className="col-md-12 text-center">
            <Buttons />
            </div></div>

        </div>

        <div className="row vertical-offset-base"><div className="col-md-12 text-center">
            <ConfirmTicketButton />
        </div></div>

        </div></div>
        </React.Fragment>

}

const Labeled = ({label, value, style={}}) => {
    return <div className="row vertical-offset-base"><div className="col-md-12">
        <div className="text-body">{label}</div>
        <div className="label text-body text-bold"><span style={style}>{value}</span></div>
        </div></div>
}


const Content = () => {
    const { bondInfo, } = useOrderTicket()
    const issue = bondInfo.issue || {}

    return <React.Fragment>
        <div className="row vertical-offset-base"><div className="col-md-12">

        <div className="container vertical-offset-base" style={{backgroundColor:'#ffffff'}}>
            <div className="row vertical-offset-base"></div>

            <div className="row vertical-offset-base"><div className="col-md-12">
                <div><label className="label">Issuer</label></div>
                <h2>{parseHtml(issue.issue)}</h2>
            </div></div>

            <div className="row vertical-offset-base"><div className="col-md-12">
            <Detail />
            </div></div>
        </div>

        </div></div>


    </React.Fragment>
}

const Detail = () => {
    const { bondInfo, orderInfo, isRfq, mode, isTreasuryAuction} = useOrderTicket()
    const netMoneyLabel = ['W','S'].indexOf(orderInfo.action)>=0 ? 'Estimated proceeds'
        : 'Estimated total cost'

    const isLift = mode === MODES.ORDER_Z
    const priceUi = orderInfo.primary==='Y' || isLift ? orderInfo.price : orderInfo.dealerPrice

    const isNoCalc = bondInfo.issue && ['O','K'].includes(bondInfo.issue.type)
    const ytm = !isNumeric(orderInfo.YTM) ? null
        : orderInfo.YTM===0.0 && isNoCalc ? null
        : orderInfo.YTM
    const ytw = !isNumeric(orderInfo.YTW) ? null
        : orderInfo.YTW===0.0 && isNoCalc ? null
        : orderInfo.YTW

    return <React.Fragment>
        <div className="table-responsive">
        <table
            className="table align-top"
        >
        <thead>
            <tr>
            <th className="text-body">Action</th>
            <th className="text-body">CUSIP</th>
            <th className="text-body">Quantity</th>
            <th className="text-body">Execution type</th>
            <th className="text-body text-right">Settlement Date</th>
            <th className="text-body text-right">Maturity Date</th>
            <th className="text-body text-right">Yield to maturity</th>
            <th className="text-body text-right">Yield to worst</th>
            <th className="text-body text-right">Price</th>
            </tr>
        </thead>
        <tbody>
            <tr>
            <td className="text-body">{getAction(orderInfo.action)}</td>
            <td className="text-body text-bold">{orderInfo.cusip}</td>
            <td className="text-body">{fmt.qty(orderInfo.qty)}</td>
            <td className="text-body">{orderInfo.executionType}</td>
            <td className="text-body text-right">{orderInfo.settlement}</td>
            <td className="text-body text-right">{orderInfo.maturity}</td>
            <td className="text-body text-right">{isNumeric(ytm) ? fmt.ytw3(ytm) : fmt.empty()}</td>
            <td className="text-body text-right">{isNumeric(ytw) ? fmt.ytw3(ytw) : fmt.empty()}</td>
            <td className="text-body text-right text-bold">{
                isTreasuryAuction ? 'Auction' :
                isNumeric(priceUi) ? '$' + fmt.price3(priceUi)
                : fmt.empty()
            }</td>
            </tr>
        </tbody>
        </table>
        <table
            className="table align-top"
            style={{borderBottom:0}}
        >
        <tbody>
            <tr>
            <td className="text-body">
                <div>Principal</div>
                <div className="text-bold">{
                    isTreasuryAuction ? fmt.empty() : fmt.money(isRfq ? 0 : orderInfo.principal)
                }</div>
            </td>
            <td className="text-body">
                <div>Accrued interest</div>
                <div className="text-bold">{
                    isTreasuryAuction ? fmt.empty()
                    : orderInfo.accruedInterest ? <React.Fragment>{fmt.money(orderInfo.accruedInterest)} ({fmt.count(orderInfo.accruedInterestDays)} days)</React.Fragment>
                    : fmt.money(isRfq ? 0 : null)
                }</div>
            </td>
            <td className="text-body">
                <div>Commission</div>
                <div className="text-bold">{
                    isTreasuryAuction ? fmt.empty() : fmt.money(isRfq ? 0 : orderInfo.sugg_comm_in_dlrs_per_tckt)
                }</div>
            </td>
            <td className="text-body">
                <div>{netMoneyLabel}</div>
                <div className="text-bold">{
                    isTreasuryAuction ? fmt.empty() : fmt.money(isRfq ? 0 : orderInfo.netMoney)
                }</div>
            </td>
            <td className="text-body text-right" colSpan={5} style={{verticalAlign:'middle'}}>
                <Buttons />
                <span aria-hidden={true} style={{padding:'0 10px 0 10px'}}></span>
                <ConfirmTicketButton cls={"btn btn-primary"} />
            </td>
            </tr>
        </tbody>
        </table>
        </div>
    </React.Fragment>
}

const Buttons = () => {
    const { setStep, from, isRfq, mode, reloadTicket } = useOrderTicket()
    return <React.Fragment>
        {[
            <React.Fragment key={1}>
            <button
                className="btn btn-link text-bold"
                onClick={(e) => {
                    setStep(STEPS.ENTRY)

                    if (isRfq || mode===MODES.ORDER_Z) {
                        return
                    }

                    reloadTicket()
                }}
            >{isRfq ? 'Change quote request' : 'Change order'}</button>
            </React.Fragment>,

            <React.Fragment key={3}>
            <button
                data-name="orders-link"
                className="btn btn-link text-bold"
                onClick={(e) => {
                    if (!from) {
                        show('overview')
                        return
                    }

                    let u = safeURL(from)
                    if (u) {
                        openWindow(u.toString())
                        return
                    }

                    viewBack()
                }}
            >Cancel</button>
            </React.Fragment>,
        ]
        .filter(Boolean)
        .flatMap( (a,i) => [a, <Sep key={i} />])
        .slice(0, -1)
        }
        </React.Fragment>
}

const ConfirmTicketButton = ({cls="btn btn-block btn-primary"} = {}) => {
    const { confirmTicket, isRfq } = useOrderTicket()

    return <button
        className={cls}
        onClick={() => {
            confirmTicket()
        }}
    >{ isRfq ? 'Place quote request' : 'Place order'}</button>

}


const Sep = () => <span aria-hidden={true} style={{padding:'0 10px 0 10px'}}>|</span>

const getAction = (a) => {
    return a==='F' ? <span><span className="text-bold" style={{color:'#107A1B'}}>Buy Quote</span><br/><span style={{fontWeight:'400'}}>(Offer wanted)</span></span> :
    a==='W' ? <span><span className="text-bold" style={{color:'#CC0000'}}>Sell Quote</span><br/><span style={{fontWeight:'400'}}>(Bid wanted)</span></span> :
    a==='B' ? <span className="text-bold" style={{color:'#107A1B'}}>Buy</span> :
    a==='S' ? <span className="text-bold" style={{color:'#CC0000'}}>Sell</span> :
    null
}


// WEBPACK FOOTER //
// ./src/order-ticket/preview.js